// extracted by mini-css-extract-plugin
export var container = "_cl-0";
export var infoIcon = "_cl-2";
export var titleRowCol = "_cl-1";